import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const testimonials = [{
  quote: "Grâce à ElevateIT, nous avons identifié et remporté trois appels d'offres majeurs au Sénégal et en Côte d'Ivoire en seulement six mois.",
  author: 'Marie Dubois',
  position: 'Directrice Export, Groupe Environnement SA',
  rating: 5,
  image: 'https://randomuser.me/api/portraits/women/45.jpg'
}, {
  quote: 'La qualité et la fraîcheur des données sont impressionnantes. Un gain de temps considérable pour notre équipe commerciale.',
  author: 'Thomas Lefèvre',
  position: 'Responsable Développement Afrique, BTP International',
  rating: 5,
  image: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  quote: "L'accompagnement personnalisé nous a permis de structurer notre approche des marchés publics africains et d'augmenter significativement notre taux de succès.",
  author: 'Sophia Benali',
  position: 'PDG, MedTech Solutions',
  rating: 4,
  image: 'https://randomuser.me/api/portraits/women/68.jpg'
}];
export function TrustSection() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-869">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-blue-100 to-transparent" data-id="element-870"></div>
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-50 rounded-full opacity-50" data-id="element-871"></div>
      <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-yellow-50 rounded-full opacity-40" data-id="element-872"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-873">
        <div className="text-center mb-16" data-id="element-874">
          <span className="inline-block px-3 py-1 bg-blue-50 text-blue-900 text-sm font-semibold rounded-full mb-4" data-id="element-875">
            Témoignages
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-876">
            Ce que nos clients disent
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-877">
            Découvrez comment ElevateIT aide les entreprises françaises à
            réussir sur les marchés africains
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-878">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 relative" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} viewport={{
          once: true
        }} data-id="element-879">
              <div className="absolute top-6 right-8 text-yellow-100" data-id="element-880">
                <QuoteIcon size={48} data-id="element-881" />
              </div>
              <div className="flex mb-4" data-id="element-882">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={18} className={i < testimonial.rating ? 'text-yellow-500' : 'text-gray-300'} fill={i < testimonial.rating ? 'currentColor' : 'none'} data-id="element-883" />)}
              </div>
              <blockquote className="text-gray-700 mb-6 relative z-10" data-id="element-884">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center mt-6" data-id="element-885">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-4 border-2 border-blue-50" data-id="element-886">
                  <img src={testimonial.image} alt={testimonial.author} className="w-full h-full object-cover" data-id="element-887" />
                </div>
                <div data-id="element-888">
                  <div className="font-semibold text-blue-900" data-id="element-889">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-gray-600" data-id="element-890">
                    {testimonial.position}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
        <motion.div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white rounded-2xl p-8 md:p-12 shadow-2xl relative overflow-hidden" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} data-id="element-891">
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-10" data-id="element-892">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-893">
              <defs data-id="element-894">
                <pattern id="dotGrid" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-895">
                  <circle cx="10" cy="10" r="1" fill="white" data-id="element-896" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#dotGrid)" data-id="element-897" />
            </svg>
          </div>
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-700 rounded-full opacity-30 transform translate-x-1/2 -translate-y-1/2" data-id="element-898"></div>
          <div className="absolute bottom-0 left-0 w-40 h-40 bg-yellow-500 rounded-full opacity-10 transform -translate-x-1/3 translate-y-1/3" data-id="element-899"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-900">
            <div data-id="element-901">
              <span className="inline-block px-3 py-1 bg-blue-800 text-yellow-500 text-sm font-semibold rounded-full mb-4" data-id="element-902">
                Passez à l'action
              </span>
              <h3 className="text-3xl font-bold mb-6 leading-tight" data-id="element-903">
                Prêt à transformer votre approche des marchés africains ?
              </h3>
              <p className="text-blue-100 mb-8 text-lg" data-id="element-904">
                Rejoignez plus de 500 entreprises françaises qui utilisent déjà
                ElevateIT pour identifier et saisir les meilleures opportunités
                d'affaires en Afrique.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-905">
                <Link to="/essai-gratuit" data-id="element-906">
                  <Button variant="primary" size="lg" className="shadow-lg shadow-yellow-500/20" data-id="element-907">
                    S'abonner maintenant
                  </Button>
                </Link>
                <Link to="/demande-demo" data-id="element-908">
                  <Button variant="outline" size="lg" className="bg-transparent border-white text-white hover:bg-blue-800" data-id="element-909">
                    Demander une démo
                  </Button>
                </Link>
              </div>
              <div className="mt-8 flex items-center text-sm text-blue-200" data-id="element-910">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-green-400" viewBox="0 0 20 20" fill="currentColor" data-id="element-911">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-912" />
                </svg>
                Essai gratuit de 7 jours • Aucun engagement
              </div>
            </div>
            <motion.div className="bg-blue-800 p-8 rounded-xl" initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-913">
              <h4 className="text-xl font-semibold mb-6 flex items-center" data-id="element-914">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-915">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-916" />
                </svg>
                Certifications et partenariats
              </h4>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-917">
                {['Business France', 'CCI International', 'MEDEF International', 'CIAN', 'OSCI', 'AFD'].map(partner => <div key={partner} className="bg-blue-700 p-4 rounded-lg text-center hover:bg-blue-600 transition-colors" data-id="element-918">
                    <span className="text-sm font-medium" data-id="element-919">{partner}</span>
                  </div>)}
              </div>
              <div className="mt-6 pt-6 border-t border-blue-700" data-id="element-920">
                <div className="flex items-center" data-id="element-921">
                  <div className="flex -space-x-2 mr-4" data-id="element-922">
                    {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-blue-800 overflow-hidden" data-id="element-923">
                        <img src={`https://randomuser.me/api/portraits/${i % 2 === 0 ? 'men' : 'women'}/${20 + i}.jpg`} alt="User" className="w-full h-full object-cover" data-id="element-924" />
                      </div>)}
                  </div>
                  <span className="text-blue-200 text-sm" data-id="element-925">
                    Rejoignez +500 entreprises
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}